import styled from 'styled-components'

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const Title = styled.h1`
  color: var(--gray-2);
  font-family: var(--primary-font);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: left;
  width: calc(100% - 54px);
  word-wrap: break-word;
`

export const Subtitle = styled.h2`
  color: var(--gray-2);
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  text-align: left;
`

export const Content = styled.p`
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  ${({ bold }) => bold && 'font-weight: 600; text-align: center;'}
  a {
    word-break: break-all;
    word-wrap: break-word;
  }
`
export const Footer = styled.footer`
  position: sticky;
  bottom: -25px;
  display: flex;
  * {
    flex: 1;
  }
  gap: 24px;
  left: 0;
  width: 100%;
  background-color: var(--the-white);
`
export const Container = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
